// src/api/axiosInstance.js
import axios from "axios";
import port from "../helper.js";

export const axiosInstance = axios.create({
    baseURL: `${port}/api/v1`,
    withCredentials: true,
});
